import {
    ChangeDetectionStrategy,
    Component,
    effect,
    forwardRef,
    HostBinding,
    inject,
    input,
    model,
    ViewEncapsulation
} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    ControlContainer,
    FormGroupDirective,
    AbstractControl,
    ControlValueAccessor,
    ValidationErrors,
    Validator
} from '@angular/forms';
import { ZSelectComponent } from '../../form-components/z-select/z-select.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import {
    BranchType,
    BranchGraphQLSchemaSelectors,
    BranchGraphQLSchemaActions,
    BranchTypeQuery
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';

@Component({
    selector: 'z-branch-select',
    imports: [ZSelectComponent, FormsModule, ReactiveFormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZBranchSelectComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZBranchSelectComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    templateUrl: `./z-branch-select.component.html`,
    styleUrl: './z-branch-select.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class ZBranchSelectComponent implements ControlValueAccessor, Validator {
    @HostBinding('class') class?: string = 'flex flex-auto';
    // @HostBinding('style') style?: string = 'flex-basis: 350px';

    label = input<string | undefined>('Υποκαταστήματα');
    autocomplete = input<string | undefined>(undefined);
    id = input<string | undefined>(undefined);
    optionLabel = input<string | undefined>('Name');
    optionValue = input<string | undefined>('_id');
    readonly = input<boolean | undefined>(undefined);
    options = model<BranchType[] | undefined>(undefined);
    placeholder = input<string | undefined>(undefined);
    inputStyle = input<
        | {
              [klass: string]: any;
          }
        | null
        | undefined
    >(undefined);

    autoSelectBranch = input<boolean>();

    store = inject(Store);

    constructor() {
        this.store
            .select(BranchGraphQLSchemaSelectors.FetchSelector('', ''))
            .pipe(takeUntilDestroyed())
            .subscribe((value) => {
                this.options.set(value?.data?.Fetch);

                if (
                    this.autoSelectBranch() == true &&
                    this.model == undefined
                ) {
                    this.model = this.options()?.[0]._id;
                    //this.onModelChange(this.model);
                }
            });
    }

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled: boolean = false;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        this.model = obj;
        if (this.autoSelectBranch() == true && this.model == undefined) {
            if ((this.options()?.length ?? 0) == 0) {
                this.store
                    .dispatch(
                        new BranchGraphQLSchemaActions.Fetch(
                            BranchTypeQuery.GQLQuery(),
                            undefined
                        )
                    )
                    .subscribe(() => {
                        this.options.set(
                            this.store.selectSnapshot(
                                BranchGraphQLSchemaSelectors.FetchSelector(
                                    '',
                                    ''
                                )
                            )?.data?.Fetch
                        );
                        this.model = this.options()?.[0]._id;
                        this.onModelChange(this.model);
                    });
            } else {
                this.model = this.options()?.[0]._id;
                this.onModelChange(this.model);
            }
        }
    }

    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        (
            this.store.selectSnapshot(
                BranchGraphQLSchemaSelectors.FetchSelector('', '')
            )?.data?.Fetch ?? []
        ).length == 0
            ? this.store.dispatch(
                  new BranchGraphQLSchemaActions.Fetch(
                      BranchTypeQuery.GQLQuery(),
                      undefined
                  )
              )
            : undefined;
    }
}
